import { useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useImmer } from 'use-immer'
import { Button, FormControl, FormLabel, Grid, GridItem, Input, Select, VStack } from '@chakra-ui/react'

export const EngineeringTableFormType = {
  Add: 'add',
  Edit: 'edit'
}

export const EngineeringTableForm = ({ type, onSubmit, isSubmitting, initialForm = null }) => {
  const [form, setForm] = useImmer({
    oahFt: '',
    oawFt: '',
    tubeSize: '',
    dualTubeSize: '',
    footerDepthIn: '',
    source: ''
  })

  const buttonText = useMemo(() => {
    switch (type) {
      case EngineeringTableFormType.Add:
        return 'Add Row'
      case EngineeringTableFormType.Edit:
        return 'Save Row'
    }
  }, [type])

  useEffect(() => {
    setForm(draft => {
      Object.keys(initialForm || {}).forEach(k => { draft[k] = initialForm[k] ?? '' })
    })
  }, [initialForm])

  const handleChange = (e) => {
    setForm(draft => {
      draft[e.target.name] = e.target.value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit({
      ...form,
      oahFt: parseInt(form.oahFt),
      oawFt: parseInt(form.oawFt),
      footerDepthIn: parseInt(form.footerDepthIn)
    })
  }

  return (
    <form onSubmit={handleSubmit}>
      <VStack gap={2} maxW="700px">
        <Grid templateColumns="1fr 1fr" gap={4} w="100%">
          <GridItem>
            <FormControl isRequired>
              <FormLabel>OAH (ft)</FormLabel>
              <Input type="number" name="oahFt" value={form.oahFt} onChange={handleChange} />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>OAW (ft)</FormLabel>
              <Input type="number" name="oawFt" value={form.oawFt} onChange={handleChange} />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Tube Size</FormLabel>
              <Input name="tubeSize" value={form.tubeSize} onChange={handleChange} placeholder='e.g. 4"x4"x1/8"' />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Dual Tube Size</FormLabel>
              <Input name="dualTubeSize" value={form.dualTubeSize} onChange={handleChange} placeholder='e.g. 3"x3"x1/8"' />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Footer Depth (inches)</FormLabel>
              <Input type="number" name="footerDepthIn" value={form.footerDepthIn} onChange={handleChange} />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl>
              <FormLabel>Source</FormLabel>
              <Select name="source" value={form.source || ''} onChange={handleChange}>
                <option value="">None</option>
                <option value="Eng. Table">Eng. Table</option>
                <option value="Extrapolated">Extrapolated</option>
              </Select>
            </FormControl>
          </GridItem>
        </Grid>
      </VStack>
      <Button type="submit" mt={8} colorScheme="blue" isLoading={isSubmitting}>{buttonText}</Button>
    </form>
  )
}

EngineeringTableForm.propTypes = {
  type: PropTypes.oneOf(Object.values(EngineeringTableFormType)).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  initialForm: PropTypes.object
}
